import { render, staticRenderFns } from "./CloseRequests.vue?vue&type=template&id=1e5d0779&scoped=true"
import script from "./CloseRequests.vue?vue&type=script&lang=js"
export * from "./CloseRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5d0779",
  null
  
)

export default component.exports